// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"style-module__checkmark___vLpcG","valid":"style-module__valid___KNVK6"};